module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10194.5accf1b9.jpg";